<template>
	<figure v-if="quoteText" data-component="article-block-quote" class="article-quote-block">
		<svg class="line" viewBox="0 0 796 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0 0.749989L530.192 0.749999C548.301 0.75 565.354 9.26999 576.228 23.75C587.102 38.23 604.155 46.75 622.263 46.75L796 46.75" stroke="#0551F5" stroke-width="1.5" />
		</svg>

		<blockquote class="-headline-4 article-quote-text">
			{{ quoteText }}
		</blockquote>

		<figcaption v-if="hasAuthor" class="article-quote-author">
			<svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M13.1233 27H0V14.5618L7.44 0H12.2967L7.02667 14.5618H13.1233V27ZM31 27H17.8767V14.5618L25.3167 0H30.1733L24.9033 14.5618H31V27Z" fill="#0551F5" />
			</svg>

			<div>
				<p v-if="authorName" class="-body-big-medium author-name">{{ authorName }}</p>
				<p v-if="authorRole" class="-body-big-regular author-role">{{ authorRole }}</p>
			</div>
		</figcaption>
	</figure>
</template>

<script setup>
const props = defineProps({
	value: { type: Object, default: undefined },
	text: { type: String, default: '' },
	author: { type: Object, default: undefined },
})

const quoteText = computed(() => props.value?.text || props.text || '')
const authorData = computed(() => props.value?.author || props.author || {})
const authorName = computed(() => authorData.value?.name || '')
const authorRole = computed(() => authorData.value?.role || '')
const hasAuthor = computed(() => Boolean(authorData.value?.enabled && (authorName.value || authorRole.value)))
</script>

<style lang="scss" scoped>
[data-component='article-block-quote'] {
	position: relative;

	margin: rs(56, 56) 0;
	display: flex;

	.line {
		position: absolute;
		top: 0;
		width: 100%;
	}

	.article-quote-text {
		@include headline-4;
		margin: 0;
		color: var(--color-river-blue-500);

		width: column-width(5, true);
		margin-top: rs(20, 20);

		@include max-width($xs) {
			width: column-width(8, true);
		}
	}

	.article-quote-author {
		color: var(--color-river-blue-500);

		width: column-width(3, true);
		display: flex;
		flex-direction: column;
		align-items: flex-end;

		@include max-width($xs) {
			width: column-width(6, true);
		}

		svg {
			margin-bottom: rs(30, 30);

			@include max-width(821px) {
				margin-top: -20px;
			}
		}

		.author-name {
			margin: 0;

			@include body-big-medium;

			@include min-width(2100px) {
				margin-top: 20px;
			}

			@include max-width(821px) {
				margin-top: 0;
			}
		}

		.author-role {
			margin: 0;

			@include body-big-regular;
		}
	}
}
</style>
